const namespace = {
  tabs: {
    transport: "Transport",
    services: "Services",
    character: "Character",
  },
  navigation: {
    more: "Read more",
    less: "Read less",
  },
  grades: {
    poor: "Poor",
    passable: "Passable",
    good: "Good",
    excellent: "Excellent",
  },
} as const;

export default namespace;
